import React from 'react';

const SeasonContext = React.createContext();

export default SeasonContext;
